<!--  -->
<template>
  <div>
    <van-nav-bar
      left-arrow
      :fixed="true"
      :title="$t('NewDish.title')"
      @click-left="$router.push('/SetMenu')"
    />
    <!-- <div style="height: 44px;"></div> -->
    <van-cell-group>
      <draggable
        v-model="menus"
        handle=".dragIcon"
        chosen-class="chosen"
        force-fallback="true"
        group="people"
        @start.stop="onStart"
        @end.stop="onEnd"
        :move="onMove"
      >
        <transition-group class="transition-wrapper" name="sort">
          <van-field
            v-for="menu in menus"
            :key="menu.id"
            v-model="menu.name"
            :readonly="isCheckboxesShow == 'none' ? false : true"
            @click="isCheckboxesShow == 'none' ? '' : toggle(index)"
            @focus="isCheckboxesShow == 'none' ? showTagBtn(index) : ''"
            @blur="
              isCheckboxesShow == 'none' ? hideTagBtn(index) : '';
              handleCategory(index);
            "
            :placeholder="menu.placeholder"
          >
            <template #left-icon>
              <van-icon name="./static/img/drag.png" class="dragIcon" />
            </template>
            <template #right-icon>
              <van-button
                class="editBtn"
                color="#1989fa"
                @click="editBtn(menu)"
                >{{ $t("ShopList.edit") }}</van-button
              >
            </template>
          </van-field>
        </transition-group>
      </draggable>
    </van-cell-group>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data() {
    return {
      menus: [],
      disabled: true,
      isCheckboxesShow: "none"
    };
  },
  mounted() {
    this.getMenus();
    this.flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
  },
  methods: {
    getMenus() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/tags/" + this.$route.params.id + "/menus"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.menus = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetMenu.message")
          });
        });
    },
    menuSort() {
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/upDown",
        data: this.data
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.getMenus();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          console.log(err);
          this.$toast.clear();
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 拖拽排序
    onStart(e) {
      console.log(e, "开始");
    },
    onEnd(e) {
      this.disabled = true;
      if (this.startItem) {
        this.data = {
          pivot_id: this.startItem.pivot.id,
          target_id: this.startItem.pivot.target_id,
          pivot_ids: this.endItem.pivot.id
        };
        this.menuSort();
      }
    },
    onMove(e, originalEvent) {
      //拖拽位置
      this.startItem = e.draggedContext.element;
      //停靠位置
      this.endItem = e.relatedContext.element;
      if (e.draggedContext.element) return false;
    },
    editBtn(menu) {
      if (menu.category == "m") {
        this.$router.push("/EditDish/" + menu.id);
      } else if (menu.category == "p") {
        this.$router.push("/EditPackage/" + menu.id);
      }
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 20px;
}
/deep/ .van-cell {
  align-items: center;
}
/deep/ .van-cell__title {
  width: 100px;
}
/deep/ .van-cell__title > span {
  display: block;
  white-space: nowrap;
  /*设置内容不换行*/
  text-overflow: ellipsis;
  /*设置文字超出文本框的内容显示成...*/
  overflow: hidden;
  /*设置超出隐藏*/
}
/deep/ .van-cell .van-icon {
  font-size: 20px;
}
/deep/ .van-cell__value {
  color: #323233;
}
/deep/ .van-field__right-icon {
  width: auto;
  display: inline-flex;
  position: relative;
}
.tagSort {
  width: 60px;
  display: flex;
  justify-content: space-around;
}
.sort-move {
  transition: transform 0.3s;
}
.dragIcon {
  position: relative;
  top: 1px;
}
</style>



// WEBPACK FOOTER //
// src/Shop/TagMenu.vue